module.exports = __webpack_public_path__ + "static/media/envelope_icon.61c37326.jpg";